//@flow

/*::
export opaque type CryptoKey: number[] = number[]
declare export function toCryptoKey(x: number[]): CryptoKey

export opaque type DCNumber: number = number
declare export function toDCNumber(x: number): DCNumber

export opaque type UID: string = string
declare export function toUID(x: string): UID

export opaque type Response: { _: string, [field: string]: any } = {
  _: string,
  [field: string]: any
}

*/
